<div class="container-fluid">
  <div class="header-container">
    <div class="page-header">
      <div class="header">{{ "bikeshop.menu.community" | translate }}</div>
    </div>  
  </div>

  <div>
    <app-menu-card [navigationItems]="navigationItems">
    </app-menu-card>
  </div>
</div>